export const state = {
  qualificationProfessionnelle: undefined,
  qualificationProfessionnelles: [],
  communes: [],
  sousQualificationProfessionnelle: undefined,
  sousQualificationProfessionnelles: []
}